import {Inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {CreaFacturaDto, ICrearPseUrlFacturacion, IDetalleFacturaRecibo, IReimpresionFactura} from "../shared/interfaces/liquidacion";
import {Observable} from "rxjs";
import {QueryParam, Utils, API_URL} from "lib-base";

@Injectable({
  providedIn: 'root'
})
export class ReciboService {
  readonly baseUrl: string;

  constructor(@Inject(API_URL) public apiUrl: string, private http: HttpClient) {
    this.baseUrl = `${this.apiUrl}/api/recibo-pago`;
  }

  createRecibo( body:CreaFacturaDto):Observable<number>{
    const url = `${this.baseUrl}/genera-factura`;
    return this.http.post<number>(url, body);
  }

  imprimir(lote: number): Observable<Blob> {
    const url = `${this.baseUrl}/impresion`;
    const params: QueryParam[] = [{key: 'lote', value: lote}];
    return this.http.get(Utils.createQueryParams(url, params),
      {responseType: "blob"});
  }

  getDetalleFactura(lote:number):Observable<IDetalleFacturaRecibo>{
    const url = `${this.baseUrl}/detalle-factura`;
    const params: QueryParam[] = [{key: 'lote', value: lote}];
    return this.http.get<IDetalleFacturaRecibo>(Utils.createQueryParams(url, params));
  }

  crearUrl(body:ICrearPseUrlFacturacion):Observable<string>{
    const url = `${this.baseUrl}/crear-url`;
    return this.http.post(url,body, {responseType: "text"});
  }

  reimpresionFactura(data: IReimpresionFactura): Observable<Blob> {
    const url = `${this.baseUrl}/reimprimir-recibo`;
    const params: QueryParam[] = [
      {key: 'loteFacturacion', value: data.loteFacturacion}
    ]

    if (data.solicitud) {
      params.push({key: 'solicitud', value: data.solicitud});
    }
    if (data.factura) {
      params.push({key: 'factura', value: data.factura});
    }
    return this.http.get(Utils.createQueryParams(url, params),{responseType: 'blob'});
  }



}
